import { render, staticRenderFns } from "./EditarTipoDispositivoModal.vue?vue&type=template&id=1a097626&"
import script from "./EditarTipoDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./EditarTipoDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports